import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setShowCaveonIdModal } from '../../../js/actions/actions'

import css from './styles.scss'

class Modal extends Component {
    
    closeCaveonIdModal = () => {
        if (this.props.lockModal) return

        this.props.dispatch(setShowCaveonIdModal(false))
    }

    render() {
        const { app: { showCaveonIdModal }, caveonIdUrl, lockModal } = this.props

        let hidden

        if (!showCaveonIdModal) {
            hidden = css.hidden
        }

        let footer

        if (!lockModal) {
            footer = (
                <div className={css.modalFooter}>
                    <button onClick={this.closeCaveonIdModal} className={css.button}>Close</button>
                </div>
            )
        }

        return (
            <div className={`${css.modal} ${hidden}`} onClick={this.closeCaveonIdModal}>
                <div className={css.modalContent} onClick={e => e.stopPropagation()}>
                    <iframe src={caveonIdUrl} id="caveonid-frame" />
                    { footer }
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { app } = state
    return {
        app
    }
}

export default connect(mapStateToProps)(Modal)


// WEBPACK FOOTER //
// /app/js/components/Modal/index.js